
import { GraphQLErrors } from '@apollo/client/errors';


export class SendOrderError extends Error {
	constructor(public err: string | Error | GraphQLErrors) {
		super(
			Array.isArray(err)
				? err.map(err => err.message).join('\n')
				: typeof err === 'string'
				? err
				: (err as Error).message
		);
	}
}

